import { render, staticRenderFns } from "./GalleryUploadFile.vue?vue&type=template&id=10e78b48&"
import script from "./GalleryUploadFile.vue?vue&type=script&lang=js&"
export * from "./GalleryUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./GalleryUploadFile.vue?vue&type=style&index=0&id=10e78b48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports